import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { CheckVersionPageRoutingModule } from './check-version-routing.module';

import { Route } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { CheckVersionPage } from './check-version.page';

@NgModule({
  imports: [CommonModule, FormsModule, IonicModule, CheckVersionPageRoutingModule, TranslateModule.forChild()],
  declarations: [CheckVersionPage]
})
export class CheckVersionPageModule {
  static route: Route = {
    path: 'check-version',
    loadChildren: async () => CheckVersionPageModule
  };
}
